var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9415 0 36 8.05852 36 18C36 27.9415 27.9415 36 18 36C8.05852 36 0 27.9415 0 18C0 8.05852 8.05852 0 18 0Z",
    fill: "#379DF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22.75V26.0985C26 26.6136 25.6136 27 25.0985 27C24.7121 27 24.3258 27 24.0682 27C15.8258 27 9 20.1742 9 11.9318C9 11.6742 9 11.4167 9 10.9015C9.12879 10.3864 9.51515 10 9.90151 10H13.25C13.5076 10 13.6364 10.1288 13.7652 10.5152C13.7652 10.6439 13.7652 10.7727 13.8939 11.0303C14.0227 12.3182 14.4091 13.6061 15.053 14.7652C15.1818 14.8939 15.053 15.1515 14.9242 15.2803L12.8636 16.5682C14.0227 19.5303 16.4697 21.7197 19.303 23.0076L20.7197 20.947C20.8485 20.8182 21.1061 20.8182 21.2348 20.8182C22.3939 21.3333 23.6818 21.7197 24.9697 21.9773C25.0985 21.9773 25.2273 21.9773 25.4848 22.1061C25.7424 22.2348 26 22.6212 26 22.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.161a38765faec5fa62addd669e20d2ae.svg";
export { ForwardRef as ReactComponent };